import React from 'react';
import PropTypes from 'prop-types';
import { Paper, TextField } from '@mui/material';

// Free-text notes block stored in extras. Unlike the sign-off recommendations field this is
// uncapped, because extras is jsonb rather than the 255-char check_sheet_report.notes column.
export default function NotesField (props) {
  const { title, value, path, onChange, readOnly, rows } = props;

  return (
    <Paper className='field-report-section'>
      <h3>{title}</h3>
      <TextField
        multiline
        rows={rows}
        fullWidth
        disabled={readOnly}
        value={value || ''}
        onChange={(e) => onChange(path, e.target.value)}
      />
    </Paper>
  );
}

NotesField.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string,
  // Full extras path, e.g. ['extras','panelInspection','recommendations'].
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  rows: PropTypes.number,
};

NotesField.defaultProps = {
  value: '',
  readOnly: false,
  rows: 6,
};
